import { ResolverTag } from '@ps/web-core-enums';
import { Translation } from '@ps/web-shared-components';
import React, { useState } from 'react';

import Iframe from '@swf/components/Iframe/Iframe';
import ResolverLink from '@swf/components/ResolverLink/ResolverLink';

import type { DepositContext, DepositResult } from '../../../../../../types/Cashier';
import ButtonGroup from '../../../../../ButtonGroup/ButtonGroup';
import CTAButton from '../../../../../CTAButton/CTAButton';
import FirstLoader from '../../../../../FirstLoader/FirstLoader';
import Prompt from '../../../../../Prompt/Prompt';
import TransitionalExitPrompt from '../../../../../TransitionalExitPrompt/TransitionalExitPrompt';

import {
  TXTCLI_PayNearMe,
  TXTWCL_Back_to_Cashier,
  TXTWCL_For_more_information_please_cl_ELL,
  TXTWCL_Generate_barcode_1,
  TXTWCL_The_PayNearMe_website_will_ope_ELL
} from './PayNearMeRedirect.messages.json';
import { content, iframe, paper } from './PayNearMeRedirect.scss';

type Props = DepositResult &
  DepositContext & {
    showPrompt?: boolean;
  };

const PayNearMeRedirect: React.FC<Props> = ({ showPrompt, redirectUrl }) => {
  const [promptVisible, setPromptVisible] = useState(false);
  const [loading, setLoading] = useState(true);

  return (
    <div>
      <Translation {...TXTWCL_The_PayNearMe_website_will_ope_ELL} />
      <Translation
        tagName="p"
        {...TXTWCL_For_more_information_please_cl_ELL}
        values={{
          a: (msg: React.ReactNode) => (
            <ResolverLink resolverTag={ResolverTag.RealMoneyPayNearMe}>{msg}</ResolverLink>
          )
        }}
      />
      <ButtonGroup>
        <CTAButton
          type="button"
          translation={TXTWCL_Generate_barcode_1}
          onClick={() => setPromptVisible(true)}
        />
        <CTAButton
          alias="firstWalletHome"
          variant="secondary"
          translation={TXTWCL_Back_to_Cashier}
        />
      </ButtonGroup>
      {promptVisible && (
        <Prompt
          variant="blank"
          classes={{ content, paper }}
          title={{
            translation: TXTCLI_PayNearMe
          }}
          onClose={() => setPromptVisible(false)}
        >
          {loading && <FirstLoader />}
          <Iframe
            className={iframe}
            src={redirectUrl.url}
            onLoad={() => setLoading(false)}
            scrolling="yes"
            data-testid="payNearMe-iframe"
          />
        </Prompt>
      )}
      {showPrompt && <TransitionalExitPrompt />}
    </div>
  );
};

export default PayNearMeRedirect;
